module.exports = __webpack_public_path__ + "static/media/205526_200175890022207_7939284_n.db653049.jpg";